import { ParameterAddDimensionPlaceholderNameCell } from './ParameterAddDimensionPlaceholderNameCell'

type Props = {
  column: number
}

export const ParameterAddDimensionPlaceholderRowCell = ({ column }: Props) => {
  if (column === 0) {
    return <ParameterAddDimensionPlaceholderNameCell />
  }

  throw new Error('Unsupported column for the dimension placeholder cell.')
}
